import React, { useEffect, useState, useMemo } from 'react';
import Modal from 'components/UI/Modal';
import ModalLayout from './ModalLayout';
import { useLang } from 'utils/localisation';
import { getOptions } from '../../utils';

function StepsModal({
  isOpen,
  closeModalCallback,
  projects,
  flags,
  defaultFilters,
  filters,
  setFilters,
}) {
  const lang = useLang();
  const [filtersCopy, setFiltersCopy] = useState({ ...filters });
  const [showTags, setShowTags] = useState(false);

  const filteredProjects = useMemo(() => {
    let result = [...projects];

    const { industries, countries } = filtersCopy;

    result = result.filter(project => {
      return (
        (!industries.length || industries.some(industry => project.industry === industry.value)) &&
        (!countries.length || countries.some(country => project.country === country.value))
      );
    });

    return result;
  }, [projects, filtersCopy]);

  const filtersOptions = useMemo(
    () => getOptions(projects, filtersCopy, lang),
    [projects, filtersCopy, lang],
  );

  useEffect(() => {
    if (isOpen) {
      setFiltersCopy({ ...filters });
    }
  }, [isOpen]);

  const handleClose = onClose => () => {
    onClose();
    setFilters(filtersCopy);
    setShowTags(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModalCallback={closeModalCallback}
      animation="right"
      theme="filterModal"
      closeButton={false}
    >
      {onClose => (
        <ModalLayout
          handleClose={handleClose(onClose)}
          filteredProjects={filteredProjects}
          filtersOptions={filtersOptions}
          flags={flags}
          showTags={showTags}
          setShowTags={setShowTags}
          filters={filtersCopy}
          defaultFilters={defaultFilters}
          setFilters={setFiltersCopy}
        />
      )}
    </Modal>
  );
}

export default StepsModal;
